goog.provide("shadow.js.shim.module$ol$interaction$Select");
goog.provide("module$shadow_js_shim_module$ol$interaction$Select");
shadow.js.shim.module$ol$interaction$Select = shadow.js.nativeProvides["ol/interaction/Select"] = shadow$bridge("ol/interaction/Select");
module$shadow_js_shim_module$ol$interaction$Select.default = shadow.js.shim.module$ol$interaction$Select;
